import { PipeTransform, Pipe } from '@angular/core';
import { ActivitiesSupport } from '../../enums/activities-support.enum';
import { enumToList } from '../enum-to-list';
import { IdName } from 'src/app/shared/models/id-name.model';

@Pipe({
  name: 'activitiesSupport',
  standalone: false
})
export class ActivitiesSupportPipe implements PipeTransform {
  public transform(value: ActivitiesSupport): string {
    return getActivitiesSupport(value);
  }
}

export function getActivitiesSupport(value: ActivitiesSupport): string {
  switch (value) {
    case ActivitiesSupport.None:
      return 'None';
    case ActivitiesSupport.Summary:
      return 'Summary';
    case ActivitiesSupport.Collecting:
      return 'Collecting';
    default:
      throw new Error(`Unsupported value for ActivitiesSupport: ${value}.`);
  }
}

export function getActivitiesSupportList(): IdName[] {
  return enumToList(ActivitiesSupport, getActivitiesSupport);
}
